export default {
  name: 'wisk-chevron-left',
  width: 35,
  height: 35,
  paths: [{ d: 'M27.883,3.163a3.155,3.155,0,0,1-.937,2.248L14.738,17.5,26.946,29.589a3.164,3.164,0,0,1-4.453,4.5L8.016,19.748a3.259,3.259,0,0,1,0-4.5L22.493.915a3.164,3.164,0,0,1,5.39,2.248Z' }]
}
